import { instanceBo } from "../utils/axios.create";
import {
	AuditlogPayload,
	AuditlogResponseBody,
	AuditlogParam,
	AuditlogPaginated,
} from "../domain/auditlog.interface";

const create = async (data: AuditlogPayload): Promise<AuditlogResponseBody> => {
	return instanceBo
		.post("/audittrails", data)
		.then((res) => res.data.body)
		.catch((err) => Promise.reject(err.response?.data || err));
};

const findByModule = async (
	data: AuditlogParam,
): Promise<AuditlogPaginated> => {
	return instanceBo
		.get(
			`/audittrails?module=${data.module}&from=${data.from}&to=${data.to}&pageNumber=${data.pageNumber}&pageSize=${data.pageSize}${data.lastDocId ? "&lastDocId=" + data.lastDocId : ""}`,
		)
		.then((res) => res.data.body)
		.catch((err) => Promise.reject(err.response?.data || err));
};

export const auditlogService = {
	create,
	findByModule,
};
